import './abt.css'
import Footer from "./footer"
import RevealTitle from "./RevealTitle";
import { motion } from "framer-motion";
import me from "../Images/Me.png";

const fadeUp = {
    hidden: { opacity: 0, y: 34 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] } },
};

const ORGS = ["Etisalat · e&", "InAmigos Foundation", "IIIT Kottayam", "Google"];

const EXPERIENCE = [
    { date: "May 2026 – Jul 2026", loc: "Internship", role: "AI Cognitive Solutions Intern", org: "Etisalat · e&" },
    { date: "May 2025 – Jun 2025", loc: "Remote", role: "UX & Graphic Designer", org: "InAmigos Foundation" },
    { date: "Present", loc: "Kottayam, India", role: "B.Tech Student", org: "IIIT Kottayam" },
];

const CERTS = [
    { org: "Google", title: "Foundations of User Experience (UX) Design" },
    { org: "Google", title: "UX Research" },
    { org: "Google", title: "Conduct UX Research & Test Early Concepts" },
    { org: "Adobe", title: "Design Fundamentals with AI" },
    { org: "Adobe", title: "Image Editing" },
];

export default function Abt() {
    return (
        <>
            {/* Title */}
            <section className="aboutHero">
                <RevealTitle text="About Me" className="aboutTitle" />
            </section>

            {/* Intro + photo */}
            <section className="section aboutIntro">
                <motion.div className="aboutBio"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <h2 className="aboutHey">Hey there, I'm Swalih</h2>
                    <p>
                        I'm Mohammed Swalih — an <span className="accent">AI engineer</span> and B.Tech
                        student at <span className="hl">IIIT Kottayam</span>. I like building intelligent,
                        practical tools: RAG chatbots, voice-AI agents, and computer-vision projects.
                    </p>
                    <p>
                        Most recently I was an <span className="hl">AI Cognitive Solutions Intern at Etisalat (e&amp;)</span>,
                        where I built four production-minded tools — a RAG medical chatbot, an ID + MRZ OCR reader,
                        a Vapi-powered AI interview bot with live feedback, and an automatic video face-blur system.
                    </p>
                    <p>
                        I come from a design and front-end background and I'm <span className="hl">Google-certified in UX</span>,
                        so I care as much about how a product feels as how its model performs. UI/UX and web
                        development are the craft I now bring around the AI I build.
                    </p>
                    <p>
                        Beyond building, I enjoy exploring where good design and AI meet.
                    </p>
                </motion.div>

                <motion.div className="aboutSide"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <div className="aboutPhoto">
                        <img src={me} alt="Mohammed Swalih" />
                    </div>
                    <div className="aboutContact">
                        <div>
                            <p className="aboutContactLabel">Email</p>
                            <a className="aboutContactValue" href="mailto:swalih3409@gmail.com">swalih3409@gmail.com</a>
                        </div>
                        <div>
                            <p className="aboutContactLabel">Location</p>
                            <p className="aboutContactValue">Kottayam, India</p>
                        </div>
                    </div>
                </motion.div>
            </section>

            {/* Orgs strip */}
            <section className="section aboutOrgs">
                <motion.h3 className="sec-label"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }}>
                    Where I've built &amp; studied
                </motion.h3>
                <div className="aboutOrgRow">
                    {ORGS.map((o) => <span key={o} className="aboutOrgName">{o}</span>)}
                </div>
            </section>

            {/* Experience timeline */}
            <section className="section aboutTimeline">
                <motion.h3 className="sec-label"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }}>
                    Experience
                </motion.h3>
                <div className="timeline">
                    {EXPERIENCE.map((e) => (
                        <div className="timelineRow" key={e.role + e.date}>
                            <div className="timelineMeta">
                                <span className="timelineDate">{e.date}</span>
                                {e.loc && <span className="timelineLoc">{e.loc}</span>}
                            </div>
                            <div className="timelineRole">
                                <h4>{e.role}</h4>
                                <p>{e.org}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Certifications */}
            <section className="section aboutTimeline">
                <motion.h3 className="sec-label"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }}>
                    Certifications
                </motion.h3>
                <div className="timeline">
                    {CERTS.map((c) => (
                        <div className="timelineRow" key={c.title}>
                            <div className="timelineMeta">
                                <span className="timelineDate">{c.org}</span>
                            </div>
                            <div className="timelineRole">
                                <h4>{c.title}</h4>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <Footer />
        </>
    )
}
